const DEFAULT_LIGHTNESS = [
  2.048875457,
  5.124792061,
  8.751659557,
  12.07628774,
  13.91449542,
  15.92738893,
  15.46585818,
  15.09779227,
  15.13738673,
  15.09818372,
];

const REDUCED_CHROMA = [
  1.762442714,
  4.213532634,
  7.395827458,
  8.07174158,
  9.89634504,
  11.37591477,
  12.27071136,
  13.54160806,
  14.35916727,
  16.88410864,
];

const DEFAULT_CHROMA = [
  1.762442714,
  4.213532634,
  7.395827458,
  11.07174158,
  13.89634504,
  16.37591477,
  16.27071136,
  16.54160806,
  17.35916727,
  19.88410864,
];

export default {
  DEFAULT_LIGHTNESS,
  REDUCED_CHROMA,
  DEFAULT_CHROMA,
};
